import { render } from "./emptyCircleIcon.svg?vue&type=template&id=24a25ec6"
const script = {}
script.render = render

export default script